import { render, staticRenderFns } from "./Tipoluogo.vue?vue&type=template&id=278b836f&scoped=true&"
import script from "./Tipoluogo.vue?vue&type=script&lang=js&"
export * from "./Tipoluogo.vue?vue&type=script&lang=js&"
import style0 from "./Tipoluogo.vue?vue&type=style&index=0&id=278b836f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b836f",
  null
  
)

export default component.exports